import { render, staticRenderFns } from "./Declaraties.vue?vue&type=template&id=4ed6b468"
import script from "./Declaraties.vue?vue&type=script&lang=js"
export * from "./Declaraties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports